import React, { PureComponent } from "react";
import "react-dates/initialize";
import { DateRangePicker, toLocalizedDateString } from "react-dates";
import {
  HORIZONTAL_ORIENTATION,
  VERTICAL_ORIENTATION,
} from "react-dates/constants";
import "react-dates/lib/css/_datepicker.css";
import Moment from "moment";
import { extendMoment } from "moment-range";
import _ from "lodash";

class DateRangePickerField extends PureComponent {
  state = { focusedInput: null, isMobile: false, allowedDates: null };
  handleFocusChange = (focusedInput) => this.setState({ focusedInput });

  componentDidMount() {
    // use css media quries
    this.isMobile = window.matchMedia("(max-width: 768px)");

    // test on first run
    this.handleIsMobile({ matches: this.isMobile.matches });

    // listen to changes after first run
    this.isMobile.addListener(this.handleIsMobile);
  }

  handleIsMobile = ({ matches }) => this.setState({ isMobile: matches });

  isBlocked = (day) => {
    let flag = _.includes(
      this.props.allowedDates,
      Moment(day).format("YYYY-MM-DD")
    );

    return !flag;
  };

  renderError({ error, touched }) {
    if (touched && error) {
      return (
        <div className="invalid-feedback d-block">
          <div className="header">
            <strong>{error}</strong>
          </div>
        </div>
      );
    }
  }

  render() {
    // let orientation = this.state.isMobile && {
    //   orientation: " VERTICAL_ORIENTATION ",
    // };

    const moment = extendMoment(Moment);
    const smallDevice = window.matchMedia("(max-width: 768px)").matches;
    const orientation = smallDevice
      ? VERTICAL_ORIENTATION
      : HORIZONTAL_ORIENTATION;

    const {
      label,
      error,
      meta,
      totalNights,
      travelFrom,
      travelTo,
      allowedDates,
      input: {
        value: { startDate = moment(allowedDates[0]), endDate = null },
        onChange,
      },
    } = this.props;
    const { focusedInput = null } = this.state;
    const minDate = moment(travelFrom[0]);
    const maxDate = moment(travelTo[travelTo.length - 1]).add(1, "days");

    //console.log(this.props);

    return (
      <>
        <label className="form-label text-uppercase small">{label}</label>
        <div className="mb-3">
          <DateRangePicker
            endDateId="endDate"
            endDate={endDate}
            endDateOffset={(day) => day.add(totalNights, "days")}
            endDatePlaceholderText="End Date"
            focusedInput={focusedInput}
            onDatesChange={onChange}
            onFocusChange={this.handleFocusChange}
            startDateId="startDate"
            startDate={startDate}
            startDatePlaceholderText="Start Date"
            displayFormat="DD-MM-YYYY"
            hideKeyboardShortcutsPanel={true}
            orientation={orientation}
            isOutsideRange={(date) =>
              date.isBefore(minDate) || date.isAfter(maxDate)
            }
            isDayBlocked={(day) => this.isBlocked(day)}
          />
          {this.renderError(meta)}
        </div>
      </>
    );
  }
}

export default DateRangePickerField;
